export default __webpack_public_path__ + "static/media/view.56322ad2.svg";